const style = () => ({
  container: {
    overflowX: 'auto',
  },
  headContainer: {
    fontSize: 14,
    display: 'flex',
    padding: 12,
  },
  headItem: {
    fontSize: 14,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    '&.isSorting': {
      cursor: 'pointer',
    },
  },
  sortableIcon: {
    display: 'block',
    width: 18,
    height: 24,
    position: 'relative',
    opacity: 0.3,
    '&:before': {
      content: '""',
      width: 0,
      height: 0,
      borderBottom: '5px solid',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',

      position: 'absolute',
      top: 'calc(50% - 7px)',
      right: 0,
    },
    '&:after': {
      content: '""',
      width: 0,
      height: 0,
      borderTop: '5px solid',
      borderLeft: '5px solid transparent',
      borderRight: '5px solid transparent',

      position: 'absolute',
      top: 'calc(50% + 1px)',
      right: 0,
    },
  },
  sortIcon: {
    transition: 'all .2s ease-in-out',
  },
  sortIconDesc: {
    transform: 'rotate(180deg)',
  },
  image: {
    border: '1px solid #C7C7C7',
    borderRadius: 5,
  },
  listContainer: {
    paddingTop: 20,
    '@media screen and (max-width: 1024px)': {
      '& > div:last-of-type': {
        paddingBottom: 50,
      },
    },
  },
  itemContainer: {
    fontSize: 13,
    padding: 12,
    WebkitUserSelect: 'none',
    KhtmlUserSelect: 'none',
    MozUserSelect: 'none',
    OUserSelect: 'none',
    userSelect: 'none',
    display: 'flex',
    '&.bgBlue': {
      background: '#FAFCFF',
    },
    '&.selected': {
      width: 'max-content',
      background: '#EDF1FB',
    },
    alignItems: 'center',
  },
  selectedButtonContainer: {
    position: 'absolute',
    bottom: -5,
    right: -5,
  },
  selectedButton: {
    margin: 0,
  },
  checkedIcon: {
    width: 15,
    height: 15,
  },
  uncheckedIcon: {
    width: 15,
    height: 15,
  },
  video: {
    width: '60px !important',
    height: '60px !important',
  },
  videoImage: {
    width: 30,
    height: 30,
    position: 'absolute',
    zIndex: 2,
    top: '25%',
    left: '25%',
  },
  videoContainer: {
    position: 'relative',
    top: 0,
    left: 0,
    bottom: 0,
    right: 0,
    border: '1px solid #C7C7C7',
    borderRadius: 5,
    '&.video': {
      height: '100%',
      width: '177.78%',
      transform: 'translateX(-50%)',
      left: '50%',
      right: 'auto',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  containerLoadMore: {
    textAlign: 'center',
    width: '100%',
    fontSize: 12,
  },
  fileName: {
    color: '#414141',
    fontSize: 13,
    marginBottom: 8,
  },
  fileDesc: {
    color: '#C7C7C7',
    fontSize: 12,
  },
})

export default style
